export default __webpack_public_path__ + "static/media/pexels-tima-miroshnichenko-5198239.21878ad0.jpg";